/* eslint-disable no-shadow */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import TableType2 from 'src/components/sharedComponents/Tablas/TableType2/TableType2';
import {
  Card,
  CardContent,
  Tab,
  Tabs,
  AppBar,
  Typography,
  CircularProgress,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Slider from '@material-ui/core/Slider';
import Skeleton from '@material-ui/lab/Skeleton';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import GetAppIcon from '@material-ui/icons/GetApp';
import SqlMode from 'src/components/insigth/SqlMode';
import { minPermisos } from 'src/constants/permits';
import SelectButton from 'src/components/insigth/SelectButton';
import DialogCon from 'src/components/insigth/DialogCon';
import Snackbar from 'src/components/sharedComponents/Snackbar/Snackbar';
import DataPikers from '@auteco/components/sharedComponents/DataPikers';
import { a11yProps } from 'src/components/sharedComponents/TapPanel';
import DialogForm from 'src/components/insigth/DialogForm';
import TapPanelChips from 'src/components/insigth/TapPanelChips';
import FieldsArray from 'src/components/insigth/FieldsArray';
import { useStyles } from './styles';

const SalesManago = (props) => {
  const {
    idTag,
    isSql,
    tags,
    field,
    level,
    value,
    fields,
    prompt,
    message,
    scheme,
    permisos,
    sqlQuery,
    permitsList,
    addFieldIn,
    onSaveField,
    onUpdateTag,
    onCreateTag,
    onDeleteTag,
    onSelectRow,
    onSelectForm,
    onClearField,
    onSelectField,
    onChangeGroup,
    onChangeField,
    loadingButton,
    handleOpenDialog,
    handleSaveSqlQuery,
    handleDownloadUsers,
    handleUpdateFieldIn,
    handleChangeSqlQuery,
    handleSendSalesManago,
    onChangeConfidenceLevel,
    countSqlConfidenceLevel,
  } = props;

  const classes = useStyles();

  const columnsSalesManago = [
    { title: 'Tag', field: 'tag', editable: 'onAdd' },
    { title: '# Usuarios', field: 'cantidad_usuarios', editable: 'never' },
    { title: 'Creación', field: 'creacion', editable: 'never' },
    {
      title: 'Estado',
      field: 'estado',
      lookup: { activo: 'Activo', inactivo: 'Inactivo' },
      defaultFilter: 'inactivo',
    },
    {
      title: 'Inicio',
      field: 'fecha_inicio',
      editComponent: (props) => <DataPikers {...props} disablePast />,
    },
    {
      title: 'Fin',
      field: 'fecha_fin',
      editComponent: (props) => <DataPikers {...props} disablePast />,
    },
    { title: 'Usuario_id', field: 'usuario_id', hidden: true },
    { title: 'id', field: 'id', hidden: true },
    { title: 'consulta', field: 'consulta', hidden: true },
  ];

  return (
    <>
      <CardTitle title="Sales Manago" />
      <Snackbar
        place="tr" // Depende la dirección en la que se va a mostrar
        color="warning"
        icon={AnnouncementIcon}
        message={message}
        open={(idTag.sql === '1' && props.loading) || level.loading} // true o false
      />
      <DialogForm
        field={field}
        fields={fields}
        open={props.open}
        onSaveField={onSaveField}
        onClearField={onClearField}
        addFieldIn={addFieldIn}
        onChangeField={handleUpdateFieldIn}
        handleOpenDialog={handleOpenDialog}
      />
      <DialogCon
        open={props.con}
        tags={tags?.tags}
        onChangeSqlStatus={props.onChangeSqlStatus}
        onSaveCon={props.handleSaveCon}
      />
      <TableType2
        dataTable={tags?.tags}
        title="Tags"
        loading={tags?.loading}
        pageSize={10}
        isSelection
        hiddenDelete
        idPermiso={permitsList.SALES_MANAGO}
        isEditableCell
        onUpdate={onUpdateTag}
        onCreate={onCreateTag}
        onDelete={onDeleteTag}
        onSelectRow={onSelectRow}
        minValue={permisos[permitsList.SALES_MANAGO]}
        columns={columnsSalesManago}
      />
      <div className={classes.root}>
        {!isSql ? (
          <>
            <AppBar position="static" color="default">
              <Tabs
                value={value}
                onChange={onChangeGroup}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
              >
                {scheme?.grupos.map(({ grupo }, index) => (
                  <Tab key={index} label={grupo} {...a11yProps(index)} />
                ))}
              </Tabs>
            </AppBar>
            <TapPanelChips
              fields={fields}
              scheme={scheme}
              value={value}
              classes={classes}
              onSelectForm={onSelectForm}
            />
            <br />
            <FieldsArray
              fields={fields}
              loading={props.loading}
              onChangeField={onChangeField}
              onSelectField={onSelectField}
              classes={classes}
            />
          </>
        ) : (
          <>
            <SqlMode
              handleChangeSqlQuery={handleChangeSqlQuery}
              handleSaveSqlQuery={handleSaveSqlQuery}
              sqlQuery={sqlQuery}
              idTag={idTag}
              level={level}
              classes={classes}
            />
          </>
        )}
        <br />
        <hr />
        <br />
        {idTag?.id && (
          <>
            <Card>
              <CardContent>
                {!isSql && (
                  <>
                    <div style={{ display: 'inline-flex' }}>
                      <Typography id="discrete-slider" gutterBottom>
                        Nivel de Confianza
                      </Typography>
                    </div>
                    <div className={classes.slider}>
                      <Slider
                        defaultValue={70}
                        // getAriaValueText={valuetext(levelSlider)}
                        aria-labelledby="discrete-slider"
                        valueLabelDisplay="auto"
                        step={1}
                        onChangeCommitted={(event, value) => onChangeConfidenceLevel(value)}
                        marks
                        min={0}
                        max={100}
                      />
                    </div>
                    <Typography id="discrete-slider" gutterBottom>
                      Cantidad de usuarios:
                      {' '}
                      {level.loading ? (
                        <Skeleton width={30} />
                      ) : (
                        level.level || idTag.cantidad_usuarios
                      )}
                    </Typography>
                  </>
                )}
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  {permisos[permitsList.SALES_MANAGO]
                    >= minPermisos.ADMINISTATIVO && (
                    <div className={classes.button}>
                      {!prompt.show ? (
                        <Button
                          variant="contained"
                          color="default"
                          onClick={handleDownloadUsers}
                          startIcon={<GetAppIcon />}
                        >
                          Descargar Usuarios
                        </Button>
                      ) : (
                        <CircularProgress />
                      )}
                    </div>
                  )}
                  <div className={classes.buttonSalesManago}>
                    {!loadingButton ? (
                      <>
                        <Button
                          disabled={
                            !(idTag?.estado === 'activo' || !level.level === 0)
                          }
                          onClick={handleSendSalesManago}
                          variant="contained"
                          className={classes.disabledButton}
                          color="secondary"
                        >
                          ENVIAR A SALES MANAGO
                        </Button>
                      </>
                    ) : (
                      <>
                        <CircularProgress />
                      </>
                    )}
                    <Button
                      disabled={
                        !(idTag?.estado === 'activo' || !level.level === 0)
                      }
                      onClick={
                        isSql
                          ? countSqlConfidenceLevel
                          : onChangeConfidenceLevel
                      }
                      variant="contained"
                      className={classes.disabledButton}
                      color="secondary"
                    >
                      CALCULAR
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          </>
        )}
        {/* <Fab onClick={onChangeSqlStatus} className={classes.con} size='medium'>
          <EditIcon />
        </Fab> */}
        <div className={classes.fab} size="medium">
          <SelectButton onChangeSqlStatus={props.onChangeSqlStatus} />
        </div>
      </div>
    </>
  );
};

export default SalesManago;
